import React, { useCallback } from "react";
import {
  buildUrl,
  BB_NHE_APPOINTMENT_ENDPOINT,
  SDA_API_URL,
  JC_API_URL,
  CSS_PAGE_URL,
  SF_NHE_STATUS_API_URL,
  SF_STEP_API_URL,
} from "../../config/urls";
import { fetchWithTimeout } from "../../helpers/fetcher";
import { useParams } from "react-router-dom";
import { isDragonstone } from "../../helpers/url-params";
import { AppointmentCardUncontrolled } from "./card-uncontrolled";
import { Stage } from "../../helpers/get-settings";

interface AppointmentCardProps {
  stage?: Stage;
}

export const AppointmentCard = ({ stage }: AppointmentCardProps) => {
  const { requisitionId, applicationId } = useParams<{
    requisitionId: string;
    applicationId: string;
  }>();

  const jcAccessor = useCallback(() => {
    const url = buildUrl(JC_API_URL, {
      applicationId,
    });
    return fetchWithTimeout(url);
  }, []) as any;

  const sdaAccessor = useCallback(() => {
    const url = buildUrl(SDA_API_URL, {
      applicationId,
    });
    return fetchWithTimeout(url);
  }, []) as any;

  const nheAccessor = useCallback(() => {
    const url = buildUrl(BB_NHE_APPOINTMENT_ENDPOINT, {
      applicationId,
    });
    return fetchWithTimeout(url);
  }, []) as any;

  const sfAccessor = useCallback(() => {
    const url = buildUrl(SF_NHE_STATUS_API_URL, {
      applicationId,
    });
    return fetchWithTimeout(url);
  }, []) as any;

  const stepAccessor = useCallback(() => {
    const url = buildUrl(SF_STEP_API_URL, {
      applicationId,
    });
    return fetchWithTimeout(url);
  }, []) as any;

  if (!isDragonstone(requisitionId)) {
    return null;
  }

  const cssURLWithoutScheduleId = buildUrl(CSS_PAGE_URL, {
    stage,
    cssPage: "no-shift-selected-ds",
    requisitionId,
    applicationId,
  });

  return (
    <AppointmentCardUncontrolled
      jcAccessor={jcAccessor}
      sdaAccessor={sdaAccessor}
      nheAccessor={nheAccessor}
      sfAccessor={sfAccessor}
      stepAccessor={stepAccessor}
      cssURLWithoutScheduleId={cssURLWithoutScheduleId}
    />
  );
};
